// import React from "react";
// import Container from "react-bootstrap/Container";
//
// const Footer = (props) => {
//   const bgStyle = { backgroundColor: "#f5f5f5" };
//
//   return (
//     <footer style={bgStyle} className="mt-auto py-5 text-center ">
//       <Container>
//         {props.children}
//         {/*<i className="fas fa-code" /> with <i className="fas fa-heart" /> by{" "}*/}
//         {/*<a*/}
//         {/*  rel="noopener"*/}
//         {/*  href="https://github.com/hashirshoaeb"*/}
//         {/*  aria-label="My GitHub"*/}
//         {/*> <span className="badge bg-dark">*/}
//         {/*    Hashir Shoaib*/}
//         {/*  </span>*/}
//         {/*</a>{" "}*/}
//         {/*using <i className="fab fa-react" />*/}
//         {/*<p>*/}
//         {/*  <small className="text-muted">*/}
//         {/*    Project code is open source. Feel free to fork and make your own*/}
//         {/*    version.*/}
//         {/*  </small>*/}
//         {/*</p>*/}
//       </Container>
//     </footer>
//   );
// };
//
// export default Footer;



import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Footer = () => {
    const bgStyle = { backgroundColor: "#f5f5f5", padding: "20px 0" };

    return (
        <footer style={bgStyle} className="text-center">
            <Container>
                <Row className="justify-content-center">
                    <Col xs={12} md={8}>
                        <h2 className="fw-light mb-4">Connect</h2>
                        <p className="fs-5 mb-2">
                            <strong>Phone:</strong>{" "}
                            <span className="fw-normal" style={{marginRight:"1.5rem"}}>+86 13951790968</span>{""}
                            <strong>E-mail:</strong>{" "}
                            <a href="mailto:wangbinworld@126.com" className="text-decoration-none">
                                wangbinworld@126.com
                            </a>
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;

